import { MKError } from "../../interfaces";

/**
 * HTTP request error class
 * @internal
 */
export class MKHttpError implements MKError {
    code: string;
    name: string;
    message: string;

    constructor(error: {code: string, message: string}) {
        this.code = error.code;
        this.name = "MKHttpError";
        this.message = error.message;
    }
}